import { heroFloat } from '@/mocks/hero';

export default function HeroFloatingType() {
  return (
    <div className="wp-float-layer pointer-events-none absolute inset-0 z-[12]" style={{ perspective: '1100px' }}>
      <div className="wp-float absolute left-[6vw] top-[30svh] text-background-50 opacity-0">
        <div className="wp-fl-group" style={{ transformStyle: 'preserve-3d', transformOrigin: '0% 50%' }}>
          <p className="wp-fl-line mb-4 text-[10px] md:text-[11px] uppercase tracking-[0.28em] text-background-100/80 whitespace-nowrap">{heroFloat.left.eyebrow}</p>
          <h2 className="font-sans font-light leading-[0.98] tracking-[-0.02em] text-[clamp(2.1rem,5.4vw,5.6rem)]">
            <span className="wp-fl-line block whitespace-nowrap">{heroFloat.left.l1}</span>
            <span className="wp-fl-line block whitespace-nowrap">{heroFloat.left.l2}</span>
          </h2>
        </div>
      </div>
      <div className="wp-float absolute right-[6.5vw] top-[53svh] text-right text-background-50 opacity-0">
        <div className="wp-fr-group" style={{ transformStyle: 'preserve-3d', transformOrigin: '100% 50%' }}>
          <p className="wp-fr-line mb-4 text-[10px] md:text-[11px] uppercase tracking-[0.28em] text-background-100/80 whitespace-nowrap">{heroFloat.right.eyebrow}</p>
          <h2 className="font-sans font-light leading-[1.02] tracking-[-0.015em] text-[clamp(1.5rem,3.4vw,3.6rem)]">
            <span className="wp-fr-line block whitespace-nowrap">{heroFloat.right.l1}</span>
            <span className="wp-fr-line block whitespace-nowrap">{heroFloat.right.l2}</span>
          </h2>
        </div>
      </div>
    </div>
  );
}